<ng-container *transloco="let t">
  <div>
    <form nzLayout="vertical" nz-form [formGroup]="this.predefinedCostForm">
      <div>
        <nz-form-item class="flex">
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-2/5 xl:w-1/3"
            nzRequired
            nzFor="Title">{{ t('settings.preferences.tourCosting.predefinedCost.form.titleLabel') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="titleCheck">
            <input
              type="text"
              nz-input
              formControlName="title"
              [placeholder]="t('settings.preferences.tourCosting.predefinedCost.form.titlePlaceholder')"/>
          </nz-form-control>
          <ng-template #titleCheck>
          <span *ngIf="formErrors.title.required">
            {{ t('settings.preferences.tourCosting.predefinedCost.form.titleRequired') }}
          </span>
          </ng-template>
        </nz-form-item>
      </div>
      <div>
  <!--      the name of the label was changed from Cost Cal Symbol to Cost Type-->
        <nz-form-item>
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-2/5 xl:w-1/3"
            nzRequired
            nzFor="costCalSymbol">
            {{ t('settings.preferences.tourCosting.predefinedCost.form.costTypeLabel') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="costCalSymbolCheck">
            <nz-select
              formControlName="costCalSymbol"
              [nzPlaceHolder]="t('settings.preferences.tourCosting.predefinedCost.form.costTypePlaceholder')">
              <nz-option *ngFor="let op of fixedPercentSymbol" [nzValue]="op.value"
                         [nzLabel]="op.label"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #costCalSymbolCheck>
              <span *ngIf="formErrors.costCalSymbol.required">
                {{ t('settings.preferences.tourCosting.predefinedCost.form.costTypeRequired') }}
              </span>
          </ng-template>
        </nz-form-item>
      </div>
      <div *ngIf="this.predefinedCostForm.get('costCalSymbol').value === this.SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.FIXED">
        <nz-form-item class="flex">
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-2/5 xl:w-1/3"
            nzRequired
            nzFor="currency"
          >{{ t('settings.preferences.tourCosting.predefinedCost.form.currencyLabel') }}</nz-form-label>
          <nz-form-control [nzErrorTip]="currencyCheck">
            <nz-select
              formControlName="currency"
              [nzPlaceHolder]="t('settings.preferences.tourCosting.predefinedCost.form.currencyPlaceholder')"
              nzShowSearch
            >
              <nz-option
                *ngFor="let cur of sortOrderCurrency(currencies)"
                [nzValue]="cur.cc"
                [nzLabel]="cur.cc">
              </nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #currencyCheck>
            <span *ngIf="formErrors.currency.required">{{ t('settings.preferences.tourCosting.predefinedCost.form.currencyRequired') }}</span>
          </ng-template>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item class="flex">
          <nz-form-label class="w-1/4 sm:w-1/5 lg:w-2/5 xl:w-1/3" nzRequired nzFor="cost">{{ t('settings.preferences.tourCosting.predefinedCost.form.costLabel') }}</nz-form-label>
          <nz-form-control [nzErrorTip]="costCheck">
            <nz-input-group nzSearch>
              <nz-input-number
                [nzFormatter]="formatter"
                [nzParser]="parser"
                [nzPrecision]="2"
                [nzStep]="0.01"
                class="w-full"
                [nzMin]="0"
                [nzPlaceHolder]="t('settings.preferences.tourCosting.predefinedCost.form.costPlaceholder')"
                formControlName="cost">
              </nz-input-number>
            </nz-input-group>
          </nz-form-control>
          <ng-template #costCheck>
              <span *ngIf="formErrors.cost.required">
                {{ t('settings.preferences.tourCosting.predefinedCost.form.costRequired') }}
              </span>
          </ng-template>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item>
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-2/5 xl:w-1/3"
            nzRequired
            nzFor="active">
            {{ t('settings.preferences.tourCosting.predefinedCost.form.statusLabel') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="activeCheck">
            <nz-select
              formControlName="active"
              [nzPlaceHolder]="t('settings.preferences.tourCosting.predefinedCost.form.statusPlaceholder')">
              <nz-option *ngFor="let op of status" [nzValue]="op.value"
                         [nzLabel]="op.label"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #activeCheck>
              <span *ngIf="formErrors.active.required">
                {{ t('settings.preferences.tourCosting.predefinedCost.form.statusRequired') }}
              </span>
          </ng-template>
        </nz-form-item>
      </div>
    </form>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">{{ t('settings.preferences.tourCosting.predefinedCost.actions.close') }}</button>
    <button nz-button nzType="primary" (click)="addEditPreCost()"
            [disabled]="this.predefinedCostForm.invalid">
      {{ this.mode === SETTINGS.PREDEFINED_COST_MODE.EDIT ? t('settings.preferences.tourCosting.predefinedCost.actions.edit') : t('settings.preferences.tourCosting.predefinedCost.actions.add') }}
    </button>
  </div>
</ng-container>
